import { render, staticRenderFns } from "./Filtros.vue?vue&type=template&id=6f7b7b48"
import script from "./Filtros.vue?vue&type=script&lang=js"
export * from "./Filtros.vue?vue&type=script&lang=js"
import style0 from "./Filtros.vue?vue&type=style&index=0&id=6f7b7b48&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7b7b48')) {
      api.createRecord('6f7b7b48', component.options)
    } else {
      api.reload('6f7b7b48', component.options)
    }
    module.hot.accept("./Filtros.vue?vue&type=template&id=6f7b7b48", function () {
      api.rerender('6f7b7b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/portal/buscador/Filtros.vue"
export default component.exports